(() => {
  const root = document.documentElement;
  const body = document.body;

  root.classList.add('scene-js');

  const onReady = () => {
    body.classList.add('scene-loaded');
    initReveal();
    initParallax();
    initHeaderState();
    initPageTransitions();
    window.setTimeout(initRecentlyViewed, 80);
  };

  const initReveal = () => {
    const revealItems = [...document.querySelectorAll('[data-scene-reveal]')];

    if (!revealItems.length) return;

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    revealItems.forEach((item) => observer.observe(item));
  };

  const initParallax = () => {
    const hero = document.querySelector('[data-scene-parallax]');
    if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;

    const update = () => {
      const rect = hero.getBoundingClientRect();
      const offset = Math.max(-220, Math.min(220, rect.top * -0.18));
      hero.style.setProperty('--scene-parallax', `${offset}px`);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
  };

  const initHeaderState = () => {
    const headerGroup = document.querySelector('#header-group');
    if (!headerGroup) return;

    let ticking = false;

    const update = () => {
      headerGroup.classList.toggle('scene-header-scrolled', window.scrollY > 18);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
  };

  const initPageTransitions = () => {
    const links = [...document.querySelectorAll('a[href]')];

    links.forEach((link) => {
      link.addEventListener('click', () => {
        const href = link.getAttribute('href');
        const target = link.getAttribute('target');
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || target === '_blank') {
          return;
        }

        try {
          const url = new URL(href, window.location.origin);
          if (url.origin !== window.location.origin) return;
          body.classList.add('scene-page-leaving');
        } catch (error) {
          // Ignore malformed theme-editor links.
        }
      });
    });
  };

  const initRecentlyViewed = () => {
    const sections = [...document.querySelectorAll('[data-scene-recently-viewed]')];
    if (!sections.length) return;

    let ids = [];

    try {
      ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]').map(String);
    } catch (error) {
      ids = [];
    }

    sections.forEach((section) => {
      const grid = section.querySelector('[data-scene-recently-grid]');
      const empty = section.querySelector('[data-scene-recently-empty]');
      const cards = [...section.querySelectorAll('[data-scene-recently-product]')];

      if (!grid || !cards.length) {
        section.classList.add('is-ready');
        return;
      }

      let visibleCount = 0;

      ids.forEach((id) => {
        const card = cards.find((item) => item.dataset.sceneRecentlyProduct === id);
        if (!card || visibleCount >= 4) return;
        card.classList.add('is-visible');
        grid.appendChild(card);
        visibleCount += 1;
      });

      if (visibleCount === 0) {
        cards.slice(0, 4).forEach((card) => {
          card.classList.add('is-visible');
          visibleCount += 1;
        });
      }

      if (empty) {
        empty.hidden = visibleCount > 0;
      }

      section.classList.add('is-ready');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();
